export default __webpack_public_path__ + "static/media/2026-03-22 18.08.37.0ee0fba2.jpg";